import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import Routes from 'src/core/Routes';
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { MainScene } from './scenes/MainScene';

interface PhaserComplexPaintDemoProps {
}

interface PhaserComplexPaintDemoState {
}

const gameConfig: GameConfig = {
    title: "Complex Paint Demo - Phaser",
    width: 800, // These are defaulted because this is an old demo
    height: 600,
    version: "0.2-demo",
    backgroundColor: "#000000"
};

class PhaserComplexPaintDemo extends React.Component<PhaserComplexPaintDemoProps, PhaserComplexPaintDemoState> {
    private game: Phaser.Game;
    constructor(props: PhaserComplexPaintDemoProps) {
        super(props);
        bindAllOfThis(this, PhaserComplexPaintDemo.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={MainScene} config={gameConfig} />
        </div>);
    }
}

export default PhaserComplexPaintDemo;



// WEBPACK FOOTER //
// ./src/games/demos/phaserComplexPaintDemo/Main.tsx